import React from "react";
import styled from "styled-components";
import QRCodeImage from "../assets/QRCodeImage.png";

const DownloadContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 2rem;
  padding: 1rem;
  background: white;
  border-right: 3px solid #00ff00;
  border-bottom: 3px solid #00ff00;
  border-radius: 16px;
  max-width: 280px;
  gap: 1rem;
  cursor: pointer;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 1100px) {
    max-width: 240px;
    padding: 1rem;
    margin-top: 1.5rem;
  }

  @media (max-width: 900px) {
    max-width: 200px;
    padding: 0.75rem;
    margin-top: 1rem;
  }
`;

const QRCodeImageContainer = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 8px;
  flex-shrink: 0;
`;

const TextContainer = styled.div`
  text-align: left;
  font-size: 20px;
  font-style: italic;
  font-weight: 900;
  font-style: bold;
  color: black;
  font-family: "Inter", sans-serif;
`;

const DownloadButton = ({ onOpenQRDialog }) => {
  return (
    <DownloadContainer onClick={onOpenQRDialog}>
      <QRCodeImageContainer
        src={QRCodeImage}
        alt="QR Code to download Plum app"
      />
      <TextContainer>SCAN TO DOWNLOAD</TextContainer>
    </DownloadContainer>
  );
};

export default DownloadButton;
